import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import {
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box
} from '@mui/material';
import { Close as CloseIcon, Phone as PhoneIcon } from '@mui/icons-material';
import GlobalStyles from 'styles/GlobalStyles';
import ProfileThreeColGrid from "components/cards/ProfileThreeColGrid.js";

// 这里是你的组件
import HomePage from "pages/GrainLandingPage"
import Terms from "pages/TermsOfService"
import Menu from "pages/MenuPage"
import OurStory from "pages/OurStory"
import CateringPage from "pages/CateringPage"
import CareersPage from "pages/CareersPage"
import BlogPage from "pages/BlogPage"
import ContactPage from "pages/ContactPage"
import DownLoadPage from "pages/DownLoadPage"
import OurFoundation from "pages/OurFoundation"
import StoresPage from "pages/StoresPage"
import RecommendOfficePage from "pages/RecommendOfficePage"
import OliveOilArticle from "pages/blog/olive-oil"
import SourdoughArticle from "pages/blog/sourdough"
import BlueZoneArticle from "pages/blog/blue-zone"
import GrainRebellionArticle from "pages/blog/grain-rebellion"
import MediterraneanWayArticle from "pages/blog/mediterranean-way"
import AvocadoOilArticle from "pages/blog/avocado-oil"

import PrivacyPolicy from "pages/PrivacyPolicy"
export default function App() {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    return (
        <>
            <GlobalStyles />
            <Router>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/menu" element={<Menu />} />
                    <Route path="/story" element={<OurStory />} />
                    <Route path="/catering" element={<CateringPage />} />
                    <Route path="/career" element={<CareersPage />} />
                    <Route path="/store" element={<StoresPage />} />
                    <Route path="/download" element={<DownLoadPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/blog/olive-oil" element={<OliveOilArticle />} />
                    <Route path="/blog/sourdough" element={<SourdoughArticle />} />
                    <Route path="/blog/blue-zone" element={<BlueZoneArticle />} />
                    <Route path="/blog/grain-rebellion" element={<GrainRebellionArticle />} />
                    <Route path="/blog/mediterranean-way" element={<MediterraneanWayArticle />} />
                    <Route path="/blog/avocado-oil" element={<AvocadoOilArticle />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/foundation" element={<OurFoundation />} />
                    <Route path="/recommend-office" element={<RecommendOfficePage />} />
                </Routes>
            </Router>

            {/* 弹窗 */}
            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                maxWidth="lg"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: 2,
                        minHeight: '60vh',
                    }
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pb: 1
                }}>
                    <IconButton
                        onClick={handleCloseDialog}
                        sx={{ p: 1 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <ProfileThreeColGrid />
                </DialogContent>

            </Dialog>
        </>
    );
}
